<template>
   <v-card class="my-5 elevation-1" outlined v-if="associations.length > 0">
      <AdCardTitle inline>{{ $t('valueset-association') }}</AdCardTitle>
      <v-card-text class="pa-0">
        <v-data-table
          v-model="selectedValueset"
          :headers="headers"
          :items="associations"
          item-key="valueSet"
          :no-data-text="$t('no-items')"
          dense
          :items-per-page="10"
          :hide-default-footer="associations.length <= 10"
          :show-select="showSelect"
          single-select
          @item-selected="onSelect"
        >
          <template #item.data-table-select="{ isSelected, select}">
            <v-tooltip top>
              <template #activator="{on}">
                <v-simple-checkbox
                  v-on="on"
                  :value="isSelected"
                  @input="select($event)"
                  :ripple="false"
                />
              </template>
              {{ $t('show-associated-concepts')}}
            </v-tooltip>
          </template>
          <template #item.valueSetName="{ item }">
            <AdButton link :to="getRouteObject(item)">
              <div class="text-no-wrap">
                {{item.valueSetName || item.valueSet}}
                <span v-if="item.valueSetVersionLabel">({{ item.valueSetVersionLabel }})</span>
              </div>
            </AdButton>
            <span v-if="item.expirationDate">{{ $t('expiration-date')}} {{ $filters.formatDateShort(item.expirationDate)}}</span>
          </template>
          <template #item.valueSetStatusCode="{ item }">
            <AdStatusDot v-if="item.valueSetStatusCode" class="pr-1" :status="item.valueSetStatusCode"  />
            <span :class="{[$filters.getConceptTypeStyling('D')]: item.expirationDate && isExpired(item.expirationDate)}">{{ $t(item.valueSetStatusCode) }}</span>
          </template>
          <template #item.flexibility="{ item }">
            <div v-if="item.flexibility" :class="{[$filters.getConceptTypeStyling('D')]: item.expirationDate && isExpired(item.expirationDate)}">
              {{ item.flexibility === 'dynamic' ? $t('dynamic') : $filters.formatDateShort(item.flexibility) }}
            </div>
            <div v-else-if="item.effectiveDate" :class="{[$filters.getConceptTypeStyling('D')]: item.expirationDate && isExpired(item.expirationDate)}">
              {{ $filters.formatDateShort(item.effectiveDate) }}
            </div>
          </template>
          <template #item.strength="{ item }">
            <span :class="{[$filters.getConceptTypeStyling('D')]: item.expirationDate && isExpired(item.expirationDate)}">{{ getCodingStrengthLabel(item.strength) }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

</template>

<script>
export default {
  name: 'ValuesetAssociationCard',
  data () {
    return {
      selectedValueset: []
    }
  },
  props: {
    associations: {
      type: Array,
      default: () => []
    },
    onSelect: {
      type: Function,
      default: () => {}
    },
    showSelect: {
      type: Boolean
    }
  },
  computed: {
    getCodingStrengthLabel () {
      return strength => {
        const match = this.decorTypes?.CodingStrengthType?.[0]?.enumeration?.find((s) => s.value === strength)
        return match
          ? this.$filters.getMatchingTranslation({ value: match.label, locale: this.$i18n.locale })
          : strength
      }
    },
    headers () {
      return [
        {
          text: this.$t('name'),
          value: 'valueSetName',
          width: '40%'
        },
        {
          text: this.$t('status'),
          value: 'valueSetStatusCode',
          width: '15%'
        },
        {
          text: this.$t('flexibility'),
          value: 'flexibility',
          width: '20%'
        },
        { text: this.$t('coding-strength'), value: 'strength', sortable: true }
      ]
    }
  },
  methods: {
    getRouteObject (valueSet) {
      if (!valueSet?.valueSet) return null
      if (!valueSet.flexibility || valueSet.flexibility === 'dynamic') return { name: 'terminology-value-set', params: { id: valueSet.valueSet } }
      return { name: 'terminology-value-set-version', params: { id: valueSet.valueSet, version: valueSet.flexibility } }
    },
    setSelectedValueSet (valueSet) {
      const vs = Array.isArray(valueSet) ? valueSet : [valueSet]
      this.selectedValueset = vs
    }
  }
}
</script>

<style lang="scss" scoped></style>
